import React, { useContext, useMemo, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import ReportList from "./ReportList";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { updateCRStatus } from "../../../network/ra-detail/services/http.services";


type CustomerReportsProps = {
    raId: string,
    raState: string,
    scenario: number,
}

export default function CustomerReports(props: CustomerReportsProps) {
    const { t } = useTranslation(['network', 'translation']);

    const [canBeConfirmed, setCanBeConfirmed] = useState(true);
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const handleConfirmButton = () => setShowConfirmPopup(true);
    const hideConfirmPopup = () => setShowConfirmPopup(false);
    const [canBeUnconfirmed, setCanBeUnconfirmed] = useState(true)
    const [showUnconfimPopup, setShowUnconfimPopup] = useState(false);
    const handleUnconfirmButton = () => setShowUnconfimPopup(true);
    const hideUnconfirmPopup = () => setShowUnconfimPopup(false);
    const { dispatchGlobalData } = useContext(GlobalContext);
    const [raCrStatus, setRaCrStatus] = useState('0')
    const ConfirmedFromClient = '2';
    const ConfirmedStatus = '3';
    const UnconfirmedStatus = '4';

    const [status, setStatus] = useState<string | null>(null);

    const checkStatusButton = useMemo(() => {
        const statusNumber = Number(raCrStatus);
        return (!isNaN(statusNumber) && statusNumber > 1) && (props.raState === 'ONGOING' || props.raState === 'CLOSED_TBC')
    },
    [props.raState, raCrStatus])

    const handleSubmitConfirm = (raId: string, status: string, scenario: number) => {
        if (status === ConfirmedStatus) {
            setCanBeConfirmed(false);
        } else if (status === UnconfirmedStatus) {
            setCanBeUnconfirmed(false)
        }

        updateCRStatus({ ra_id: raId, status: status, scenario: scenario }).then((response: any) => {
            //console.log("handleSubmitConfirm response:", response);
            if (status === ConfirmedStatus && response.data.status === ConfirmedStatus) {
                //viewMessage(t('raDetail.customerReports.successUpdateStatus'), snackbarTypes.success);
                setStatus(ConfirmedStatus);
                setCanBeConfirmed(false);
                setCanBeUnconfirmed(true);
            } else {
                //viewMessage(t('raDetail.customerReports.errorUpdateStatus'), snackbarTypes.error);
                setCanBeConfirmed(true);
                setCanBeUnconfirmed(false);
            }

            if (status === UnconfirmedStatus && response.data.status === ConfirmedFromClient) {
                setStatus(ConfirmedFromClient);
                setCanBeConfirmed(true);
                setCanBeUnconfirmed(false);
            } else {
                //viewMessage(t('raDetail.customerReports.errorUpdateStatus'), snackbarTypes.error);
                setCanBeConfirmed(false);
                setCanBeUnconfirmed(true);
            }
            viewMessage(t('raDetail.customerReports.successUpdateStatus'), snackbarTypes.success);

        })
            .catch((error: any) => {
                console.error("Errore nel handleSubmitConfirm:", error);
                viewMessage(t('raDetail.customerReports.errorUpdateStatus'), snackbarTypes.error);
                if (status === ConfirmedStatus) {
                    setCanBeConfirmed(true);
                    setCanBeUnconfirmed(false);
                } else if (status === UnconfirmedStatus) {
                    setCanBeConfirmed(false);
                    setCanBeUnconfirmed(true);
                }
            });
        hideConfirmPopup();
        hideUnconfirmPopup();
    }

    const viewMessage = (message: string, type = snackbarTypes.error) => {
        dispatchGlobalData({
            type: 'SET_SNACKBAR',
            payload: {
                snackbar: {
                    message: t(message),
                    type: type,
                    show: true,
                    autoClose: true,
                }
            }
        });
    }

    return (<>
        <Stack rowGap={2}>
            <Stack direction="row" justifyContent="end">
                {
                    <>
                        {checkStatusButton && <>
                            {canBeConfirmed && <Button variant="outlined"
                                onClick={handleConfirmButton}
                                disabled={!canBeConfirmed} >
                                {t("raDetail.customerReports.confirm")}
                            </Button>}
                            {canBeUnconfirmed && <Button variant="outlined"
                                onClick={handleUnconfirmButton}
                                disabled={!canBeUnconfirmed} >
                                {t("raDetail.customerReports.unconfirm")}
                            </Button>}

                        </>}
                    </>
                }
            </Stack>

            <ReportList
                raId={props.raId}
                scenario={props.scenario}
                setCanBeConfirmed={setCanBeConfirmed}
                setCanBeUnconfirmed={setCanBeUnconfirmed}
                setRaCrStatus={setRaCrStatus}
                status={status} />
        </Stack>

        <Dialog
            open={showConfirmPopup}
            onClose={hideConfirmPopup}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {t("raDetail.customerReports.dialog.title")}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {t("raDetail.customerReports.dialog.content")}
                </DialogContentText>
            </DialogContent>
            <DialogActions>

                <Button onClick={hideConfirmPopup} variant={"outlined"} color={"accent"}>
                    {t("raDetail.customerReports.dialog.action.cancel")}
                </Button>

                <Button onClick={() => handleSubmitConfirm(props.raId, ConfirmedStatus, props.scenario)} autoFocus>
                    {t("raDetail.customerReports.dialog.action.confirm")}
                </Button>

            </DialogActions>
        </Dialog>

        <Dialog
            open={showUnconfimPopup}
            onClose={hideUnconfirmPopup}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {t("raDetail.customerReports.dialog.title")}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {t("raDetail.customerReports.dialog.content")}
                </DialogContentText>
            </DialogContent>
            <DialogActions>

                <Button onClick={hideUnconfirmPopup} variant={"outlined"} color={"accent"}>
                    {t("raDetail.customerReports.dialog.action.cancel")}
                </Button>

                <Button onClick={() => handleSubmitConfirm(props.raId, UnconfirmedStatus, props.scenario)} autoFocus>
                    {t("raDetail.customerReports.dialog.action.confirm")}
                </Button>

            </DialogActions>
        </Dialog>
    </>)
}
